document.addEventListener('DOMContentLoaded', function () {
    // Native <select> elements don't open their dropdown on Enter — the
    // browser instead treats Enter as an implicit form submit. Stop that
    // and open the dropdown instead (showPicker requires a user gesture,
    // which this keydown is).
    document.querySelectorAll('select').forEach(function (select) {
        select.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter') return;
            e.preventDefault();
            if (typeof select.showPicker === 'function') {
                select.showPicker();
            }
        });
    });
});

//# sourceMappingURL=select-a11y.js.map
